import { render, staticRenderFns } from "./Carnival.vue?vue&type=template&id=22fa1407&"
import script from "./Carnival.vue?vue&type=script&lang=js&"
export * from "./Carnival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports